import { CContainer, CSpinner } from "@coreui/react";
import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoutes from "../../auth/ProtectedRoute";
import AdminEdit from "../AdminEdit/AdminEdit";
import RealEstateManagment from "../Company/RealEstateManagment";

import AssetsApprove from "../FormData/AssetsApprove";
import BidNow from "../FormData/BidNow";
import TrendingStocks from "../FormData/TrendingStocks";
import UserInquiries from "../FormData/UserInquiries";
import ViewSell from "../FormData/ViewSell";
// import ByWalletManagement from "../transactions/ByWalletManagement";
// import ByProductManagement from "../transactions/ByProductManagement";

import UserManagement from "../UserManagement/UserManagement";
import AboutManagement from "../UserManagement/AboutManagement";
import "./scss/appContent.scss";
import Roles from "../Roles/Roles";
import RolesAdd from "../Roles/RolesAdd";
import Employeemanage from "../Employee/Employeemanage";
import Employeeadd from "../Employee/Employeeadd";
import EditEmployeemanage from "../Employee/EditEmployeemanage";
import EditRoles from "../Roles/EditRoles";
import { useState } from "react";
import { useEffect } from "react";
import adminAxiosInstance from "../../../config";
import Main from "../../auth/Main";
import { useSelector } from "react-redux";
// import EditAboutManagement from "../UserManagement/EditAboutManagement";
// import Clain from "../FormData/Clain";

const EditByProduct = React.lazy(() => import("../transactions/EditByProduct"));
const EditByWallet = React.lazy(() => import("../transactions/EditByWallet"));

const EquityEdit = React.lazy(() => import("../Company/EquityEdit"));
const Faq = React.lazy(() => import("../FAQ/Faq"));
const Glossary = React.lazy(() => import("../Glossary/Glossary"));
const StaffManagement = React.lazy(() => import("../Staff/StaffManagement"));
const UserList = React.lazy(() => import("../UserManagement/UserList"));
const OtpList = React.lazy(() => import("../UserManagement/otp"));
const CpList = React.lazy(() => import("../CpManagement/CpList"));
const CpManagement = React.lazy(() => import("../CpManagement/CpManagement"));
const EditCpManagement = React.lazy(() =>
  import("../CpManagement/EditCpManagement")
);
const CpSupport = React.lazy(() => import("../CpManagement/CpSupport"));
const CpKyc = React.lazy(() => import("../CpManagement/CpKyc"));
const CpKycDetails = React.lazy(() => import("../CpManagement/CpKycDetails"));
const EditCpKyc = React.lazy(() => import("../CpManagement/EditCpKyc"));
const ChartList = React.lazy(() => import("../ChartManagement/ChartList"));
const ChartManagement = React.lazy(() =>
  import("../ChartManagement/ChartManagement")
);
const EditChart = React.lazy(() => import("../ChartManagement/EditChart"));

const EditStaff = React.lazy(() => import("../Staff/EditStaff"));
const AssignStaff = React.lazy(() => import("../Staff/AssignStaff"));
const Userkyc = React.lazy(() => import("../UserManagement/userkyc"));

const AssociatePartners = React.lazy(() =>
  import("../UserManagement/AssociatePartners")
);
const DeleteUserRequest = React.lazy(() =>
  import("../UserManagement/DeleteUserRequest")
);
const EditUserManagement = React.lazy(() =>
  import("../UserManagement/EditUserManagement")
);
const EditHelthManagement = React.lazy(() =>
  import("../UserManagement/EditHelthManagement")
);
const ViewHealthManagement = React.lazy(() =>
  import("../UserManagement/ViewHealthManagement")
);
const EditAboutManagement = React.lazy(() =>
  import("../UserManagement/EditAboutManagement")
);
const EditTwoWheelerManagement = React.lazy(() =>
  import("../TwoWheeler/EditTwowheelermanagement")
);
const ViewTwoWheelerManagement = React.lazy(() =>
  import("../TwoWheeler/ViewTwowheelermanagement")
);
const EditTermFormmanagement = React.lazy(() =>
  import("../TermForm/EditTermFormmanagement")
);
const ViewTermFormmanagement = React.lazy(() =>
  import("../TermForm/ViewTermFormmanagement")
);
const EditTravelFormmanagement = React.lazy(() =>
  import("../TravelForm/EditTravelFormmanagement")
);
const ViewTravelManagement = React.lazy(() =>
  import("../TravelForm/ViewTravelFormmanagement")
);
const EditFourwheelerManagement = React.lazy(() =>
  import("../FourWheeler/EditFourwheelermanagement")
);
const ViewFourwheelerManagement = React.lazy(() =>
  import("../FourWheeler/ViewFourwheelermanagement")
);

const ByTwowheeler = React.lazy(() => import("../transactions/ByTwowheeler"));
const ByFourwheeler = React.lazy(() =>
  import("../transactions/ByFourwheeler ")
);
const ByHealth = React.lazy(() => import("../transactions/ByHealth"));
const ByTravel = React.lazy(() => import("../transactions/ByTravel"));
const ByTerms = React.lazy(() => import("../transactions/ByTerms"));
const ByProductManagement = React.lazy(() =>
  import("../transactions/ByProductManagement")
);
const ByWalletManagement = React.lazy(() =>
  import("../transactions/ByWalletManagement")
);
const EditRealEstate = React.lazy(() => import("../Company/EditRealEstate"));
const ViewContact = React.lazy(() => import("../FormData/ViewContact"));
const UpcomingIPOs = React.lazy(() =>
  import("../FormData/UpcomingIPo/UpcomingIPOs")
);
const IpoManagement = React.lazy(() =>
  import("../FormData/UpcomingIPo/IpoManagement")
);
const EditIpoManagement = React.lazy(() =>
  import("../FormData/UpcomingIPo/EditIpoManagement")
);
// const KycDetails = React.lazy(() => import("../Kyc/KycDetails"));
const Equities = React.lazy(() => import("../Company/Equities"));
const RealEstate = React.lazy(() => import("../Company/RealEstate"));
const EquityManagment = React.lazy(() =>
  import("../Company/EquitiesManagment")
);

const Dashboard = React.lazy(() => import("../Dashboard/Dashboard"));
//Blog
const Blog = React.lazy(() => import("../Blog/Blog"));
const BlogManagement = React.lazy(() => import("../Blog/BlogManagement"));
const EditBlog = React.lazy(() => import("../Blog/EditBlog"));

//FormData
const Contacthome = React.lazy(() => import("../FormData/Contactform"));
const Abouthealth = React.lazy(() => import("../FormData/Abouthealth"));
const Claim = React.lazy(() => import("../FormData/Claim"));
// const Contacthome = React.lazy(() => import("../FormData/Contacthome"));
const Healthform = React.lazy(() => import("../FormData/Healthform"));
const Fourwheeler = React.lazy(() => import("../FormData/Fourwheeler"));
const Twowheeler = React.lazy(() => import("../FormData/Twowheeler"));
const Tearms = React.lazy(() => import("../FormData/Tearms"));
const Travel = React.lazy(() => import("../FormData/Travel"));
const Sell = React.lazy(() => import("../FormData/Sell"));
const Contact = React.lazy(() => import("../FormData/Contact"));
const NewsLetter = React.lazy(() => import("../FormData/NewsLetter"));
const Partner = React.lazy(() => import("../FormData/Partner"));
const ErrorPage = React.lazy(() => import("../FormData/Inthenews/errror"));
const InternalApi = React.lazy(() =>
  import("../FormData/Inthenews/InternalApi")
);
const ThirdParty = React.lazy(() => import("../FormData/Inthenews/ThirdParty"));
const AddInthenews = React.lazy(() =>
  import("../FormData/Inthenews/AddInthenews")
);
const EditInthenews = React.lazy(() =>
  import("../FormData/Inthenews/EditInthenews")
);
const Quotation = React.lazy(() => import("../document/Quotation"));
const CategoryAndPlans = React.lazy(() =>
  import("../catergoryPlans/CategoryandPlans")
);
const AddOnsList = React.lazy(() =>
  import("../catergoryPlans/AddOns/AddOnsList")
);
const NewAddOns = React.lazy(() =>
  import("../catergoryPlans/AddOns/NewAddOns")
);
const EditAddOns = React.lazy(() =>
  import("../catergoryPlans/AddOns/EditAddOns")
);
const PlanDetails = React.lazy(() =>
  import("../catergoryPlans/PlanDetails/PlanDetails")
);
const AddCategory = React.lazy(() =>
  import("../catergoryPlans/PlanDetails/AddCategory")
);
const AddCategoryAndPlans = React.lazy(() =>
  import("../catergoryPlans/AddCategoryandPlan/AddNewCategoryandPlan")
);
const EditCategoryAndPlans = React.lazy(() =>
  import("../catergoryPlans/AddCategoryandPlan/EditNewCategoryandPlan")
);
const AboutUsHealth = React.lazy(() =>
  import("../aboutUs/HealthFormPlanDetail")
);
const AboutushealthAddCoverages = React.lazy(() =>
  import("../aboutUs/HealthFormAddCoverages")
);
const AboutushealthHospitals = React.lazy(() =>
  import("../aboutUs/HealthFormHospitals")
);
const AboutushealthClaim = React.lazy(() =>
  import("../aboutUs/HealthFormClaim")
);
const AboutushealthCompany = React.lazy(() =>
  import("../aboutUs/HealthFormComapany")
);
const AddHospitals = React.lazy(() =>
  import("../aboutUs/AddHospitals/AddNewCashlessHospitals")
);
const EditCashlessHospitals = React.lazy(() =>
  import("../aboutUs/AddHospitals/EditCashlessHospitals")
);

const ManageApi = React.lazy(() => import("../manageApi/manageApi"));
const AddManageApi = React.lazy(() => import("../manageApi/AddManageApi"));
const EditManageApi = React.lazy(() => import("../manageApi/EditManageApi"));
const VehicleLookup = React.lazy(() => import("../manageApi/VehicleLookup"));
const DocumentManagment = React.lazy(() =>
  import("../document/DocumentManagment")
);
const EditDocument = React.lazy(() => import("../document/EditDocument"));
//Job and Staff
const Staff = React.lazy(() => import("../Staff/Staff"));
const JobApplication = React.lazy(() => import("../FormData/JobApplication"));

//Header
const Header = React.lazy(() => import("../Header/Header"));

const AppContent = () => {
  const [roledata, setRoleData] = useState([]);
  const adminToken = localStorage.getItem("token");

  const sidebarShow = useSelector((state) => state.changeState.sidebarShow);

  const fetchData = async () => {
    try {
      const response = await adminAxiosInstance.get(`/auth/checkPermissions`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      });
      // const accessData = response.data.data?.adminRoles?.Access || [];
      if (response?.data?.data) {
        setRoleData(response?.data?.data?.adminRoles?.Access);
      }
      // setTimeout(() => {

      // }, 1000);
    } catch (error) {
      // Handle error
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const isAuthenticated = () => {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };
  const isAuth = isAuthenticated();

  // console.log(roledata,"getparmiison")
  return (
    <>
      {sidebarShow ? (
        <div className="dashbaord-rightside">
          <Suspense
            fallback={
              <>
                <div className="loader-content">
                  <CSpinner color="secondary" />
                </div>
              </>
            }>
            <Routes>
              {/* Dashboard */}
              <Route element={<ProtectedRoutes />}>
                {isAuth ? (
                  <Route path="/dashboard" element={<Dashboard />} />
                ) : (
                  <Route
                    path="/"
                    element={<Navigate replace to="/admin/login" />}
                  />
                )}
                {/* <Route path="/dashboard" element={<Dashboard />} />             */}
                <Route path="/admin-edit" element={<AdminEdit />} />
                <Route
                  path="/"
                  element={<Navigate replace to="/admin/dashboard" />}
                />
                <Route
                  path="*"
                  element={<Navigate replace to="/admin/dashboard" />}
                />

                {/* Blog  */}
                <Route path="/" element={<Main moduleType="Blog" />}>
                  <Route path="/blog" element={<Blog />} />
                  <Route
                    path="/blog/blogmanagement"
                    element={<BlogManagement />}
                  />
                  <Route
                    path="/blog/blogmanagement/:id"
                    element={<EditBlog />}
                  />
                </Route>

                {/* Roles */}
                <Route path="/" element={<Main moduleType="roles" />}>
                  <Route path="/roles" element={<Roles />} />
                  <Route path="/roles/addroles" element={<RolesAdd />} />
                  <Route path="/roles/editRoles/:id" element={<EditRoles />} />
                </Route>

                {/* employee managament */}
                <Route
                  path="/"
                  element={<Main moduleType="Employee Management" />}>
                  <Route
                    path="/employeemanagement"
                    element={<Employeemanage />}
                  />
                  <Route
                    path="/employeemanagement/addemployee"
                    element={<Employeeadd />}
                  />
                  <Route
                    path="/employeemanagement/editemployee/:id"
                    element={<EditEmployeemanage />}
                  />
                </Route>

                {/* FormData */}

                <Route
                  path="/formdata/viewcontact/:id"
                  element={<ViewContact />}
                />

                <Route path="/" element={<Main moduleType="Contactform" />}>
                  <Route
                    path="/formdata/contactform"
                    element={<Contacthome />}
                  />
                  <Route
                    path="/formdata/abouthealth"
                    element={<Abouthealth />}
                  />
                  <Route path="/formdata/claimform" element={<Claim />} />
                </Route>

                <Route path="/" element={<Main moduleType="Healthform" />}>
                  <Route path="/formdata/healthform" element={<Healthform />} />
                </Route>
                <Route path="/" element={<Main moduleType="Twowheeler" />}>
                  <Route path="/formdata/twowheeler" element={<Twowheeler />} />
                </Route>
                <Route path="/" element={<Main moduleType="Fourwheeler" />}>
                  <Route
                    path="/formdata/fourwheeler"
                    element={<Fourwheeler />}
                  />
                </Route>
                <Route path="/" element={<Main moduleType="Tearms" />}>
                  <Route path="/formdata/term" element={<Tearms />} />
                </Route>
                <Route path="/" element={<Main moduleType="Travel" />}>
                  <Route path="/formdata/travel" element={<Travel />} />
                </Route>

                <Route path="/" element={<Main moduleType="Sell" />}>
                  <Route path="/formdata/sell" element={<Sell />} />
                </Route>
                <Route path="/formdata/sell/:id" element={<ViewSell />} />

                <Route path="/" element={<Main moduleType="Watchlist" />}>
                  <Route
                    path="/formdata/watchlist"
                    element={<TrendingStocks />}
                  />
                </Route>

                <Route path="/formdata/bid-now" element={<BidNow />} />
                <Route path="/upcoming-ipos" element={<UpcomingIPOs />} />
                <Route
                  path="/upcoming-ipos/edit-ipos/:id"
                  element={<EditIpoManagement />}
                />
                <Route
                  path="/upcoming-ipos/add-ipos"
                  element={<IpoManagement />}
                />

                <Route path="/" element={<Main moduleType="Contact" />}>
                  <Route path="/formdata/contact" element={<Contact />} />
                </Route>

                <Route
                  path="/formdata/user-inquiry"
                  element={<UserInquiries />}
                />
                <Route path="/formdata/newsletter" element={<NewsLetter />} />
                <Route path="/formdata/partner" element={<Partner />} />

                <Route path="/" element={<Main moduleType="In The News" />}>
                  <Route path="/formdata/errorpage" element={<ErrorPage />} />
                  <Route
                    path="/formdata/internalapi"
                    element={<InternalApi />}
                  />
                  <Route path="/formdata/thirdparty" element={<ThirdParty />} />
                </Route>

                <Route
                  path="/formdata/inthenews/addinthenews"
                  element={<AddInthenews />}
                />
                <Route
                  path="/formdata/inthenews/:id"
                  element={<EditInthenews />}
                />
                <Route
                  path="/formdata/assetapprove"
                  element={<AssetsApprove />}
                />

                {/* <Route path="/" element={<Main moduleType="Job Application" />} >    
              <Route
                path="/formdata/job-application" element={<JobApplication />}
                />
                </Route>
         */}

                {/* Staff Management  */}
                <Route path="/" element={<Main moduleType="Staff" />}>
                  <Route path="/staff" element={<Staff />} />
                </Route>

                <Route
                  path="/staff/staffmanagement"
                  element={<StaffManagement />}
                />
                <Route
                  path="/staff/staffmanagement/:id"
                  element={<EditStaff />}
                />
                <Route
                  path="/staff/staffmanagement/assign/:id"
                  element={<AssignStaff />}
                />

                {/* User Management */}

                <Route path="/" element={<Main moduleType="kyc" />}>
                  {/* <Route path="/kyc" element={<Userkyc />} /> */}
                </Route>

                <Route
                  path="/"
                  element={<Main moduleType="AssociatePartners" />}>
                  <Route path="/associatepartners" element={<AssociatePartners />} />
                </Route>

                <Route
                  path="/"
                  element={<Main moduleType="DeleteUserRequest" />}>
                  <Route path="/deleteuser" element={<DeleteUserRequest />} />
                </Route>

                <Route path="/" element={<Main moduleType="User" />}>
                  <Route path="/userlist" element={<UserList />} />
                </Route>

                <Route path="/" element={<Main moduleType="Otp" />}>
                  <Route path="/otplist" element={<OtpList />} />
                </Route>

                <Route
                  path="/healthform/edithelthmanagement/:id"
                  element={<EditHelthManagement />}
                />
                <Route
                  path="/healthform/viewhelthmanagement/:id"
                  element={<ViewHealthManagement />}
                />
                <Route
                  path="/healthform/editaboutmanagement/:id"
                  element={<EditAboutManagement />}
                />
                <Route
                  path="/userlist/editusermanagement/:id"
                  element={<EditUserManagement />}
                />
                <Route
                  path="/twowheeler/edittwowheelerManagement/:id"
                  element={<EditTwoWheelerManagement />}
                />
                <Route
                  path="/twowheeler/viewtwowheelerManagement/:id"
                  element={<ViewTwoWheelerManagement />}
                />
                <Route
                  path="/termform/edittermformmanagement/:id"
                  element={<EditTermFormmanagement />}
                />
                <Route
                  path="/termform/viewtermformmanagement/:id"
                  element={<ViewTermFormmanagement />}
                />
                <Route
                  path="/travelform/edittravelformmanagement/:id"
                  element={<EditTravelFormmanagement />}
                />
                <Route
                  path="/travelform/viewtravelformmanagement/:id"
                  element={<ViewTravelManagement />}
                />
                <Route
                  path="/fourwheeler/editfourwheelermanagement/:id"
                  element={<EditFourwheelerManagement />}
                />
                <Route
                  path="/fourwheeler/viewfourwheelermanagement/:id"
                  element={<ViewFourwheelerManagement />}
                />
                <Route
                  path="/userlist/usermanagement"
                  element={<UserManagement />}
                />
                <Route
                  path="/formdata/abouthealth/aboutmanagement/:id"
                  element={<AboutManagement />}
                />
                {/* Cp Management */}
                <Route path="/" element={<Main moduleType="Cp List" />}>
                  <Route path="/cplist" element={<CpList />} />
                </Route>

                <Route path="/" element={<Main moduleType="Cp Kyc" />}>
                  <Route path="/cpkyc" element={<CpKyc />} />
                </Route>

                <Route path="/cplist/cpmanagement" element={<CpManagement />} />
                <Route path="/cpsupport" element={<CpSupport />} />
                <Route
                  path="/cpkyc/cpkycdetails/:id"
                  element={<CpKycDetails />}
                />
                <Route path="/cpkyc/editcpkyc/:id" element={<EditCpKyc />} />
                <Route
                  path="/cplist/editcpmanagement/:id"
                  element={<EditCpManagement />}
                />
                {/* chart management */}

                <Route path="/" element={<Main moduleType="Chart List" />}>
                  <Route path="/chartlist" element={<ChartList />} />
                </Route>

                <Route
                  path="/chartlist/chartmanagement"
                  element={<ChartManagement />}
                />
                <Route
                  path="/chartlist/editchart/:id"
                  element={<EditChart />}
                />
                {/* Unlisted Comanies */}

                <Route path="/" element={<Main moduleType="Equity" />}>
                  <Route
                    path="/equity-crowdfunding/equities"
                    element={<Equities />}
                  />
                </Route>

                <Route path="/" element={<Main moduleType="Real Estate" />}>
                  <Route
                    path="/equity-crowdfunding/real-estate"
                    element={<RealEstate />}
                  />
                </Route>

                <Route
                  path="/equity-crowdfunding/real-estate/:id"
                  element={<EditRealEstate />}
                />
                <Route
                  path="/equity-crowdfunding/real-estate/add-real-estate"
                  element={<RealEstateManagment />}
                />
                <Route
                  path="/equity-crowdfunding/equity/add-equity"
                  element={<EquityManagment />}
                />
                <Route
                  path="/equity-crowdfunding/real-estate/add-equity"
                  element={<EquityManagment />}
                />
                <Route path="/property-edit/:id" element={<EquityEdit />} />

                {/* transactions  */}

                <Route path="/" element={<Main moduleType="two-wheeler" />}>
                  <Route path="/two-wheeler" element={<ByTwowheeler />} />
                </Route>

                <Route
                  path="/by-product/by-productmanagment"
                  element={<ByProductManagement />}
                />
                <Route path="/by-product/:id" element={<EditByProduct />} />

                <Route path="/" element={<Main moduleType="health" />}>
                  <Route path="/health" element={<ByHealth />} />
                </Route>
                <Route path="/" element={<Main moduleType="travel" />}>
                  <Route path="/travel" element={<ByTravel />} />
                </Route>
                <Route path="/" element={<Main moduleType="terms" />}>
                  <Route path="/terms" element={<ByTerms />} />
                </Route>

                <Route path="/" element={<Main moduleType="four-wheeler" />}>
                  <Route path="/four-wheeler" element={<ByFourwheeler />} />
                </Route>
                <Route
                  path="by-wallet/by-walletmanagment"
                  element={<ByWalletManagement />}
                />
                <Route path="/by-wallet/:id" element={<EditByWallet />} />

                <Route path="/" element={<Main moduleType="quotation" />}>
                  <Route path="/quotation" element={<Quotation />} />
                </Route>
                <Route
                  path="/"
                  element={<Main moduleType="categoryandplans" />}>
                  <Route
                    path="/categoryandplans"
                    element={<CategoryAndPlans />}
                  />
                  <Route path="/addons" element={<AddOnsList />} />
                  <Route path="/addons/addnew" element={<NewAddOns />} />
                  <Route
                    path="/addons/editaddons/:id"
                    element={<EditAddOns />}
                  />

                  <Route path="/plandetails" element={<PlanDetails />} />
                  <Route
                    path="/plandetails/addcategory"
                    element={<AddCategory />}
                  />
                  <Route
                    path="/categoryandplans/addnewcategoryandplans"
                    element={<AddCategoryAndPlans />}
                  />
                  <Route
                    path="/categoryandplans/editnewcategoryandplans/:id"
                    element={<EditCategoryAndPlans />}
                  />
                </Route>
                <Route path="/" element={<Main moduleType="manageapi" />}>
                  <Route path="/manageapi" element={<ManageApi />} />
                  <Route
                    path="/manageapi/addmanageapi"
                    element={<AddManageApi />}
                  />
                  <Route
                    path="/manageapi/editmanageapi/:id"
                    element={<EditManageApi />}
                  />
                  <Route
                    path="/vehiclelookup"
                    element={<VehicleLookup />}
                  />
                </Route>
                <Route
                  path="/"
                  element={<Main moduleType="aboutushealthform" />}>
                  <Route
                    path="/aboutushealthform"
                    element={<AboutUsHealth />}
                  />
                  <Route
                    path="/aboutushealthaddcoverages"
                    element={<AboutushealthAddCoverages />}
                  />
                  <Route
                    path="/aboutushealthhospitals"
                    element={<AboutushealthHospitals />}
                  />
                  <Route
                    path="/aboutushealthclaim"
                    element={<AboutushealthClaim />}
                  />
                  <Route
                    path="/aboutushealthcompany"
                    element={<AboutushealthCompany />}
                  />
                  <Route
                    path="/aboutushealthform/addnewhospitals"
                    element={<AddHospitals />}
                  />
                  <Route
                    path="/aboutushealthform/editcashlesshospital/:id"
                    element={<EditCashlessHospitals />}
                  />
                </Route>
                <Route
                  path="/document/documentmanagment"
                  element={<DocumentManagment />}
                />
                <Route
                  path="/document/editdocument/:id"
                  element={<EditDocument />}
                />
                {/* KYC  */}
                {/* <Route path="/kyc/kyclist" element={<KycList />} /> */}
                {/* <Route path="/kyc/kycdetails/:id" element={<KycDetails />} /> */}

                {/* FAQ and Glossary */}
                {/* <Route path="/" element={<Main moduleType="FAQs" />} >  
            <Route path="/faq" element={<Faq />} />
              </Route>  */}

                {/*               
              <Route path="/" element={<Main moduleType="document" />} >  
            <Route path="/glossary" element={<Glossary />} />
              </Route> */}

                {/* Headers */}
                <Route path="/" element={<Main moduleType="FAQS" />}>
                  <Route path="/header/:id" element={<Header />} />
                </Route>
                {/* </Route> */}
              </Route>
            </Routes>
          </Suspense>
        </div>
      ) : (
        <div className="dashbaord-rightside">
          <Suspense
            fallback={
              <>
                <div className="loader-content ">
                  <CSpinner color="secondary" />
                </div>
              </>
            }>
            <Routes>
              {/* Dashboard */}
              {/* <Route element={<ProtectedRoutes />}> */}
              {isAuth ? (
                <Route path="/dashboard" element={<Dashboard />} />
              ) : (
                <Route
                  path="/"
                  element={<Navigate replace to="/admin/login" />}
                />
              )}
              {/* <Route path="/dashboard" element={<Dashboard />} />             */}
              <Route path="/admin-edit" element={<AdminEdit />} />
              <Route
                path="/"
                element={<Navigate replace to="/admin/dashboard" />}
              />
              <Route
                path="*"
                element={<Navigate replace to="/admin/dashboard" />}
              />

              {/* Blog  */}
              <Route path="/" element={<Main moduleType="Blog" />}>
                <Route path="/blog" element={<Blog />} />
                <Route
                  path="/blog/blogmanagement"
                  element={<BlogManagement />}
                />
                <Route path="/blog/blogmanagement/:id" element={<EditBlog />} />
              </Route>

              {/* Roles */}
              <Route path="/" element={<Main moduleType="roles" />}>
                <Route path="/roles" element={<Roles />} />
                <Route path="/roles/addroles" element={<RolesAdd />} />
                <Route path="/roles/editRoles/:id" element={<EditRoles />} />
              </Route>

              {/* employee managament */}
              <Route
                path="/"
                element={<Main moduleType="Employee Management" />}>
                <Route
                  path="/employeemanagement"
                  element={<Employeemanage />}
                />
                <Route
                  path="/employeemanagement/addemployee"
                  element={<Employeeadd />}
                />
                <Route
                  path="/employeemanagement/editemployee/:id"
                  element={<EditEmployeemanage />}
                />
              </Route>

              {/* FormData */}

              <Route
                path="/formdata/viewcontact/:id"
                element={<ViewContact />}
              />

              <Route path="/" element={<Main moduleType="Contactform" />}>
                <Route path="/formdata/contactform" element={<Contacthome />} />
                <Route path="/formdata/abouthealth" element={<Abouthealth />} />
                <Route path="/formdata/claimform" element={<Claim />} />
              </Route>

              <Route path="/" element={<Main moduleType="Healthform" />}>
                <Route path="/formdata/healthform" element={<Healthform />} />
              </Route>
              <Route path="/" element={<Main moduleType="Twowheeler" />}>
                <Route path="/formdata/twowheeler" element={<Twowheeler />} />
              </Route>
              <Route path="/" element={<Main moduleType="Fourwheeler" />}>
                <Route path="/formdata/fourwheeler" element={<Fourwheeler />} />
              </Route>
              <Route path="/" element={<Main moduleType="Tearms" />}>
                <Route path="/formdata/term" element={<Tearms />} />
              </Route>
              <Route path="/" element={<Main moduleType="Travel" />}>
                <Route path="/formdata/travel" element={<Travel />} />
              </Route>

              <Route path="/" element={<Main moduleType="Sell" />}>
                <Route path="/formdata/sell" element={<Sell />} />
              </Route>
              <Route path="/formdata/sell/:id" element={<ViewSell />} />

              <Route path="/" element={<Main moduleType="Watchlist" />}>
                <Route
                  path="/formdata/watchlist"
                  element={<TrendingStocks />}
                />
              </Route>

              <Route path="/formdata/bid-now" element={<BidNow />} />
              <Route path="/upcoming-ipos" element={<UpcomingIPOs />} />
              <Route
                path="/upcoming-ipos/edit-ipos/:id"
                element={<EditIpoManagement />}
              />
              <Route
                path="/upcoming-ipos/add-ipos"
                element={<IpoManagement />}
              />

              <Route path="/" element={<Main moduleType="Contact" />}>
                <Route path="/formdata/contact" element={<Contact />} />
              </Route>

              <Route
                path="/formdata/user-inquiry"
                element={<UserInquiries />}
              />
              <Route path="/formdata/newsletter" element={<NewsLetter />} />
              <Route path="/formdata/partner" element={<Partner />} />

              <Route path="/" element={<Main moduleType="In The News" />}>
                <Route path="/formdata/errorpage" element={<ErrorPage />} />
                <Route path="/formdata/internalapi" element={<InternalApi />} />
                <Route path="/formdata/thirdparty" element={<ThirdParty />} />
              </Route>

              <Route
                path="/formdata/inthenews/addinthenews"
                element={<AddInthenews />}
              />
              <Route
                path="/formdata/inthenews/:id"
                element={<EditInthenews />}
              />
              <Route
                path="/formdata/assetapprove"
                element={<AssetsApprove />}
              />

              {/* <Route path="/" element={<Main moduleType="Job Application" />} >    
              <Route
                path="/formdata/job-application" element={<JobApplication />}
                />
                </Route>
         */}

              {/* Staff Management  */}
              <Route path="/" element={<Main moduleType="Staff" />}>
                <Route path="/staff" element={<Staff />} />
              </Route>

              <Route
                path="/staff/staffmanagement"
                element={<StaffManagement />}
              />
              <Route
                path="/staff/staffmanagement/:id"
                element={<EditStaff />}
              />
              <Route
                path="/staff/staffmanagement/assign/:id"
                element={<AssignStaff />}
              />

              {/* User Management */}

              {/* <Route path="/" element={<Main moduleType="kyc" />} >     */}
              {/* <Route path="/kyc" element={<Userkyc />} /> */}
              {/* </Route> */}

              <Route path="/" element={<Main moduleType="AssociatePartners" />}>
                <Route path="/associatepartners" element={<AssociatePartners />} />
              </Route>

              <Route path="/" element={<Main moduleType="DeleteUserRequest" />}>
                <Route path="/deleteuser" element={<DeleteUserRequest />} />
              </Route>

              <Route path="/" element={<Main moduleType="User" />}>
                <Route path="/userlist" element={<UserList />} />
              </Route>

              <Route path="/" element={<Main moduleType="Otp" />}>
                <Route path="/otplist" element={<OtpList />} />
              </Route>

              <Route
                path="/healthform/edithelthmanagement/:id"
                element={<EditHelthManagement />}
              />
              <Route
                path="/healthform/viewhelthmanagement/:id"
                element={<ViewHealthManagement />}
              />
              <Route
                path="/healthform/editaboutmanagement/:id"
                element={<EditAboutManagement />}
              />
              <Route
                path="/userlist/editusermanagement/:id"
                element={<EditUserManagement />}
              />
              <Route
                path="/fourwheeler/editfourwheelermanagement/:id"
                element={<EditFourwheelerManagement />}
              />
              <Route
                path="/fourwheeler/viewfourwheelermanagement/:id"
                element={<ViewFourwheelerManagement />}
              />
              <Route
                path="/userlist/usermanagement"
                element={<UserManagement />}
              />
              <Route
                path="/formdata/abouthealth/aboutmanagement/:id"
                element={<AboutManagement />}
              />
              {/* Cp Management */}
              <Route path="/" element={<Main moduleType="Cp List" />}>
                <Route path="/cplist" element={<CpList />} />
              </Route>

              <Route path="/" element={<Main moduleType="Cp Kyc" />}>
                <Route path="/cpkyc" element={<CpKyc />} />
              </Route>

              <Route path="/cplist/cpmanagement" element={<CpManagement />} />
              <Route path="/cpsupport" element={<CpSupport />} />
              <Route
                path="/cpkyc/cpkycdetails/:id"
                element={<CpKycDetails />}
              />
              <Route path="/cpkyc/editcpkyc/:id" element={<EditCpKyc />} />
              <Route
                path="/cplist/editcpmanagement/:id"
                element={<EditCpManagement />}
              />
              {/* chart management */}

              <Route path="/" element={<Main moduleType="Chart List" />}>
                <Route path="/chartlist" element={<ChartList />} />
              </Route>

              <Route
                path="/chartlist/chartmanagement"
                element={<ChartManagement />}
              />
              <Route path="/chartlist/editchart/:id" element={<EditChart />} />
              {/* Unlisted Comanies */}

              <Route path="/" element={<Main moduleType="Equity" />}>
                <Route
                  path="/equity-crowdfunding/equities"
                  element={<Equities />}
                />
              </Route>

              <Route path="/" element={<Main moduleType="categoryandplans" />}>
                <Route
                  path="/categoryandplans"
                  element={<CategoryAndPlans />}
                />
                <Route path="/addons" element={<AddOnsList />} />
                <Route path="/addons/addnew" element={<NewAddOns />} />
                <Route path="/addons/editaddons/:id" element={<EditAddOns />} />
                <Route path="/plandetails" element={<PlanDetails />} />
                <Route
                  path="/plandetails/addcategory"
                  element={<AddCategory />}
                />

                <Route
                  path="/categoryandplans/addnewcategoryandplans"
                  element={<AddCategoryAndPlans />}
                />
                <Route
                  path="/categoryandplans/editnewcategoryandplans/:id"
                  element={<EditCategoryAndPlans />}
                />
              </Route>
              <Route path="/" element={<Main moduleType="manageapi" />}>
                <Route path="/manageapi" element={<ManageApi />} />
                <Route
                  path="/manageapi/addmanageapi"
                  element={<AddManageApi />}
                />
                <Route
                  path="/manageapi/editmanageapi"
                  element={<EditManageApi />}
                />
                <Route
                  path="/vehiclelookup"
                  element={<VehicleLookup />}
                />
              </Route>

              <Route path="/" element={<Main moduleType="Real Estate" />}>
                <Route
                  path="/equity-crowdfunding/real-estate"
                  element={<RealEstate />}
                />
              </Route>

              <Route
                path="/equity-crowdfunding/real-estate/:id"
                element={<EditRealEstate />}
              />
              <Route
                path="/equity-crowdfunding/real-estate/add-real-estate"
                element={<RealEstateManagment />}
              />
              <Route
                path="/equity-crowdfunding/equity/add-equity"
                element={<EquityManagment />}
              />
              <Route
                path="/equity-crowdfunding/real-estate/add-equity"
                element={<EquityManagment />}
              />
              <Route path="/property-edit/:id" element={<EquityEdit />} />

              {/* transactions  */}

              <Route path="/" element={<Main moduleType="two-wheeler" />}>
                <Route path="/two-wheeler" element={<ByTwowheeler />} />
              </Route>

              <Route
                path="/by-product/by-productmanagment"
                element={<ByProductManagement />}
              />
              <Route path="/by-product/:id" element={<EditByProduct />} />

              <Route path="/" element={<Main moduleType="health" />}>
                <Route path="/health" element={<ByHealth />} />
              </Route>
              <Route path="/" element={<Main moduleType="travel" />}>
                <Route path="/travel" element={<ByTravel />} />
              </Route>
              <Route path="/" element={<Main moduleType="terms" />}>
                <Route path="/terms" element={<ByTerms />} />
              </Route>

              <Route path="/" element={<Main moduleType="four-wheeler" />}>
                <Route path="/four-wheeler" element={<ByFourwheeler />} />
              </Route>

              <Route
                path="by-wallet/by-walletmanagment"
                element={<ByWalletManagement />}
              />
              <Route path="/by-wallet/:id" element={<EditByWallet />} />

              <Route path="/" element={<Main moduleType="quotation" />}>
                <Route path="/quotation" element={<Quotation />} />
              </Route>
              <Route path="/" element={<Main moduleType="aboutushealthform" />}>
                <Route path="/aboutushealthform" element={<AboutUsHealth />} />
                <Route
                  path="/aboutushealthaddcoverages"
                  element={<AboutushealthAddCoverages />}
                />
                <Route
                  path="/aboutushealthhospitals"
                  element={<AboutushealthHospitals />}
                />
                <Route
                  path="/aboutushealthclaim"
                  element={<AboutushealthClaim />}
                />
                <Route
                  path="/aboutushealthcompany"
                  element={<AboutushealthCompany />}
                />
                <Route
                  path="/aboutushealthform/addnewhospitals"
                  element={<AddHospitals />}
                />
                <Route
                  path="/aboutushealthform/editcashlesshospital/:id"
                  element={<EditCashlessHospitals />}
                />
              </Route>
              <Route
                path="/document/documentmanagment"
                element={<DocumentManagment />}
              />
              <Route
                path="/document/editdocument/:id"
                element={<EditDocument />}
              />
              <Route
                path="/twowheeler/edittwowheelerManagement/:id"
                element={<EditTwoWheelerManagement />}
              />
              <Route
                path="/twowheeler/viewtwowheelerManagement/:id"
                element={<ViewTwoWheelerManagement />}
              />
              <Route
                path="/termform/edittermformmanagement/:id"
                element={<EditTermFormmanagement />}
              />
              <Route
                path="/termform/viewtermformmanagement/:id"
                element={<ViewTermFormmanagement />}
              />
              <Route
                path="/travelform/edittravelformmanagement/:id"
                element={<EditTravelFormmanagement />}
              />
              <Route
                path="/travelform/viewtravelformmanagement/:id"
                element={<ViewTravelManagement />}
              />
              {/* KYC  */}
              {/* <Route path="/kyc/kyclist" element={<KycList />} />
          <Route path="/kyc/kycdetails/:id" element={<KycDetails />} /> */}

              {/* FAQ and Glossary */}
              {/* <Route path="/" element={<Main moduleType="FAQs" />} >  
            <Route path="/faq" element={<Faq />} />
              </Route>  */}

              {/*               
              <Route path="/" element={<Main moduleType="document" />} >  
            <Route path="/glossary" element={<Glossary />} />
              </Route> */}

              {/* Headers */}
              <Route path="/" element={<Main moduleType="FAQS" />}>
                <Route path="/header/:id" element={<Header />} />
              </Route>
            </Routes>
          </Suspense>
        </div>
      )}
    </>
  );
};

export default React.memo(AppContent);
